import { ReactNode } from 'react';

import useFreeBetsTitle from './useFreeBetsTitle';
import usePledgeStakesTitle from './usePledgeStakesTitle';

// ---

type DisabledTitles = {
  pledgeStakes?: string;
  freeBets?: ReactNode;
};

const useDisabledEntryTitles = (betId: number): DisabledTitles => {
  const freeBets = useFreeBetsTitle(betId);
  const pledgeStakes = usePledgeStakesTitle(betId);
  return {
    pledgeStakes,
    freeBets,
  };
};

export default useDisabledEntryTitles;
